import CustomList from '../../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../../core/components/core/Util/List/CustomList/CustomListContainer';
import config from '../../../config/config';
import { chooseProfileFilter } from '../../../helpers/chooseProfileFilter';
import { loadData } from '../../../../core/components/core/Util/List/CustomList/loadData';
import { useNavigate } from 'react-router-dom';

function List() {
  const profileFilter = chooseProfileFilter();
  const navigate = useNavigate();

  const pathFrontEnd = '/entityemployees/';
  const paths = {
    pathAdd: pathFrontEnd + 'add',
    pathEdit: pathFrontEnd + 'edit',
    pathView: pathFrontEnd + 'view',
    endpointGetAllEntities: config.endpoints.backend + 'entities/getall',
    endpointDelete: config.endpoints.backend + 'fileentityemployees/delete',
    endpoint: config.endpoints.backend + 'fileentityemployees/getall'
  }

  const filters = {
    validateOnChange: true,
    showGoBackButton: false,
    showSubmitButton: false,
    handleSubmit: loadData,
    fields: [
      {
        name: 'pdc_entity_id',
        type: 'select',
        label: 'Entidade',
        options: [],
        optionsEndpoint: {
          endpoint: paths.endpointGetAllEntities,
          label: 'corporate_name',
          value: 'id',
          params: {
            filter: {
              ...profileFilter
            }
          }
        },
        validations: {
          required: false
        },
        columnSize: 3,
      },
      {
        name: 'filtro',
        type: 'submit',
        label: 'Pesquisar',
        columnSize: 1
      },
      {
        name: 'reset',
        type: 'reset',
        label: 'Limpar',
        columnSize: 2
      },
    ]
  }

  let list = {
    labelTitle: 'Lista de Importações de Empregados',
    labelTitleButtonAdd: 'Incluir novo empregado',
    fieldsShowOnDelete: ['entity_name'],
    showPrintButtons: true,
    canAdd: false,
    canEdit: false,
    canView: false,
    formFilters: !profileFilter.pdc_entity_id ? filters : null,
    filter: {
      ...profileFilter
    },
    columns: [
      {
        name: 'entity_name',
        label: 'Entidade',
      },
      {
        name: 'imported_begin',
        label: 'Início em',
        width: '15%'
      },
      {
        name: 'imported_finish',
        label: 'Finalizado em',
        width: '15%'
      },
      {
        name: 'formatted_status',
        label: 'Status',
      },
      {
        name: 'system',
        label: 'Integração',
      },
    ],
    buttonsListContainer: [
      {
        name: 'go_back_entity_employees',
        class: 'btn btn-secondary',
        label: 'Voltar',
        tooltipLabel: 'Voltar',
        callback: async () => {
          navigate(`/entityemployees/entities`)
        }
      }
    ],
  };

  list = { ...list, ...paths };

  return (
    <div>
      <CustomListContainer
        buttons={list.buttonsListContainer}
        canAdd={list.canAdd}
        pathAdd={list.pathAdd}
        labelTitle={list.labelTitle}
        labelTitleButtonAdd={list.labelTitleButtonAdd}
        content={<CustomList list={{ ...list, ...paths }} />}
      />
    </div>
  );
}
export default List;
